import React from "react";
import { Input } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Input announcement for convention form.
 */
export const InputAnnouncement = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-announcement-error",
  };

  const inputProps = {
    type: "text",
    id: "input-announcement",
    className: "form-control convention-input",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "ANNOUNCEMENT",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.ANNOUNCEMENT,
  };

  return <Input {...parentProps} />;
};
